var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('px-go-to-login-block',{scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-img',_vm._g({staticClass:"pointer-cursor",attrs:{"height":"350px","src":_vm.thumbImage}},on))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }